import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { get, set, del } from 'idb-keyval'

const storage = {
    getItem: async (name: string): Promise<string | null> => {
        return (await get(name)) || null
    },
    setItem: async (name: string, value: string): Promise<void> => {
        await set(name, value)
    },
    removeItem: async (name: string): Promise<void> => {
        await del(name)
    },
}

export const useZustandStore = create(
    persist(
        (set) => ({
            moneylineDays: 1,
            setMoneylineDays: (value) => set(() => ({ moneylineDays: value })),
        }), {
        name: 'longbow-storage',
        storage: createJSONStorage(() => storage),
    })
);